import { Pipe, PipeTransform } from '@angular/core';
import {EnergieEnum} from '../suivi-des-consommations/enums/EnergieEnum';

@Pipe({
    name: 'energieIcon',
    standalone: false
})
export class EnergieIconPipe implements PipeTransform {

  transform(energie: EnergieEnum, ...args: unknown[]): unknown {
    switch (energie){
      case EnergieEnum.ELECTRICITE: return 'icon-clea-electricite';
      case EnergieEnum.GAZ: return 'icon-clea-gaz';
      case EnergieEnum.EAU: return 'icon-clea-eau';
      case EnergieEnum.RESEAU_CHALEUR: return 'icon-clea-chauffage';
      case EnergieEnum.BOIS: return null;
      case EnergieEnum.FIOUL: return 'icon-clea-eau';
      case EnergieEnum.HYBRIDE: return null;
      case EnergieEnum.HYBRIDE2: return null;
      case EnergieEnum.CHAUFFAGE: return 'icon-clea-chauffage';
      case EnergieEnum.ECS: return 'icon-clea-eau-chaude';
      case EnergieEnum.REFROIDISSEMENT: return 'icon-clea-electricite';
    }
  }

}
